import { interval, Observable, Subscription } from 'rxjs';

export class MyTimer {
  private timerSubscription: Subscription;
  private time: number;
  private timerObservable: Observable<number>;
  public showTime: string;

  constructor(private days: number, private hours: number, private minutes: number , private secondes: number) {
    this.time = this.convertToMilliseconds(days, hours, minutes, secondes);
    this.timerObservable = interval(1000); // Émet une valeur toutes les secondes (1000 millisecondes)
  }

  private convertToMilliseconds(days: number, hours: number, minutes: number , seconde: number): number {
    const millisecondsPerSeconde = 1000
    const millisecondsPerMinute = 60 * millisecondsPerSeconde;
    const millisecondsPerHour = 60 * millisecondsPerMinute;
    const millisecondsPerDay = 24 * millisecondsPerHour;

    return (days * millisecondsPerDay) + (hours * millisecondsPerHour) + (minutes * millisecondsPerMinute) + (seconde * millisecondsPerSeconde);
  }

  private formatTime(milliseconds: number): string {
    let days = Math.floor(milliseconds / (24 * 60 * 60 * 1000));
    let hours = Math.floor((milliseconds % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
    let minutes = Math.floor((milliseconds % (60 * 60 * 1000)) / (60 * 1000));
    let seconds = Math.floor((milliseconds % (60 * 1000)) / 1000);

    if(days < 0){
       days = 0;
    }
    if(hours < 0){
      hours = 0;
    }
    if(minutes < 0){
      minutes = 0;
    }
    if(seconds < 0){
      seconds = 0;
    }

    if(days < 0 && hours < 0 && minutes < 0 && seconds < 0){
      this.showTime = "En cours";
    }else{
      this.showTime = `${days} jour(s), ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }

    return `${days} jour(s), ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  startTimer(): void {
    this.timerSubscription = this.timerObservable.subscribe(() => {
      this.time -= 1000; // Décrémente d'une seconde (1000 millisecondes)
      if (this.time >= 0) {
        this.formatTime(this.time);
      } else {
        this.stopTimer();
      }
    });
  }

  stopTimer(): void {
    this.timerSubscription.unsubscribe();
    this.time = 0;
  }
}
